import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 update_stock_movement_suspension_settings: { message: "idle" },
};

export const update_stock_movement_suspension_settings_Slice = createSlice({
 name: "update_stock_movement_suspension_settings",
 initialState,
 reducers: {
  success_update_stock_movement_suspension_settings: (state, action) => {
   state.update_stock_movement_suspension_settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_update_stock_movement_suspension_settings: (state, action) => {
   state.update_stock_movement_suspension_settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_update_stock_movement_suspension_settings: (state) => {
   state.update_stock_movement_suspension_settings = { status: app_consts.IDLE };
  },
  loading_update_stock_movement_suspension_settings: (state) => {
   state.update_stock_movement_suspension_settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_update_stock_movement_suspension_settings, fail_update_stock_movement_suspension_settings, reset_update_stock_movement_suspension_settings, loading_update_stock_movement_suspension_settings } = update_stock_movement_suspension_settings_Slice.actions;

export default update_stock_movement_suspension_settings_Slice.reducer;